import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { Router } from '@angular/router';
import { CoreService } from '../core/core.service';
import { NotUsingMyVehicleService } from '../not-using-my-vehicle/not-using-my-vehicle.service';
import { UserProvider } from '../providers/user-provider.ts/user-provider';

@Injectable({
  providedIn: 'root',
})
export class DeclarationLifecycleService {
  private initialized = false;

  private readonly visibilityChangeHandler = () => {
    if (
      globalThis.document.visibilityState === 'visible' &&
      !this.isNotUsingMyVehicleRoute()
    ) {
      void this.onAppActive();
    }
  };

  constructor(
    private readonly router: Router,
    private readonly coreService: CoreService,
    private readonly userProvider: UserProvider,
    private readonly notUsingMyVehicleService: NotUsingMyVehicleService,
  ) { }

  async initializeDeclarationCheck(): Promise<void> {
    if (this.initialized || !navigator.onLine) {
      return;
    }

    this.initialized = true;

    if (this.coreService.isMobileApp) {
      void this.onAppActive();

      // Native app lifecycle
      App.addListener('appStateChange', ({ isActive }) => {
        if (isActive && !this.isNotUsingMyVehicleRoute()) {
          void this.onAppActive();
        }
      });

    }

    // Web lifecycle
    if (!this.coreService.isMobileApp) {
      globalThis.document.addEventListener(
        'visibilitychange',
        this.visibilityChangeHandler
      );

      return;
    }

  }

  private isNotUsingMyVehicleRoute(): boolean {
    return this.router.url.startsWith('/not-using-my-vehicle');
  }

  private async onAppActive(): Promise<void> {
    if (!navigator.onLine) {
      if (this.isNotUsingMyVehicleRoute()) {
        await this.router.navigateByUrl('/dashboard');
      }
      return;
    }

    const currentUser = this.userProvider.getCurrentUserData;
    const hasValidCurrentUser =
      currentUser?.state === 'Valid' &&
      !!currentUser.accessToken?.token;

    if (!this.userProvider.readIsLoggedIn() && !hasValidCurrentUser) {
      return;
    }

    const declaration = await this.notUsingMyVehicleService.getDeclarationFromSql();

    if (await this.notUsingMyVehicleService.shouldPromptDeclaration(declaration) && !this.isNotUsingMyVehicleRoute()) {
      await this.router.navigateByUrl('/not-using-my-vehicle');
    }
  }
}